@let alertInstances = model.alertInstances$();
@let alertInstanceCount = alertInstances.length;

<div class="alert-icon-wrapper" data-link-ga-node="NotificationList_BellIcon" [attr.data-link-ga-details]="{'numberOfNotifications': alertInstanceCount} | json" (click)="op.toggle($event); handle('NotificationListToggled')">
  @if(alertInstanceCount > 0) {
    <i class="pi pi-bell alert-icon" pBadge severity="danger" [value]="alertInstanceCount"></i>
  }
  @else {
    <i class="pi pi-bell alert-icon"></i>
  }
</div>

<p-overlayPanel #op [styleClass]="'notification-list-overlay-panel'">
  <div class="notification-list-container" data-link-ga-root="NotificationList" [attr.data-link-ga-details]="{'numberOfNotifications': alertInstanceCount} | json">
    <div class="notification-list-title">
      <!-- TDC - TODO - create translation token -->
      Notifications
    </div>

    @if(alertInstanceCount > 0) {
      <div class="notification-list">
        @for(alertInstance of alertInstances; track alertInstance.id) {
          <div class="alert-instance-wrapper" [@fadeAnimation]="alertInstance.id === lastRemovedAlertInstance?.id ? 'notVisible' : 'visible'">
            <link-alert-instance [mode]="'list'"
                                 [alertInstance]="alertInstance"
                                 (onClose)="removeAlertInstance(alertInstance)">

            </link-alert-instance>
          </div>
        }
      </div>
    }
    @else {
      <div class="empty-notification-message">
        <!-- TDC - TODO - create translation token -->
        You have no notifications
      </div>
    }

    @if(alertInstanceCount > 1) {
      <div class="d-flex justify-content-center mt-2">
        <button mat-flat-button data-link-ga-node="RemoveAll" (click)="removeAll()">
          <mat-icon>close</mat-icon>
          {{'t.createAlertRemoveAll' | translate}}
        </button>
      </div>
    }
    @else if(alertInstanceCount === 0) {
      <div class="d-flex justify-content-center mt-2">
        <button mat-flat-button data-link-ga-node="RemoveAll" class="w-100 ms-2 me-2 mb-2" (click)="handle('NavigateToAlertMonitor', {event: $event}); op.toggle($event)">
          <img src="./assets/icons/menu/alert-menu-icon.png" class="me-2" />
          {{'Alert Monitor'}} <!-- TDC - TODO - create translation token -->
        </button>
      </div>
    }
  </div>
</p-overlayPanel>

